import { asyncRequest } from './asyncRequest'

export const studentConstants = {
    STUDENT_GET_USER_INFO: new asyncRequest('STUDENT_GET_USER_INFO'),
    STUDENT_SET_USER_DASHBOARD_LANGUAGE: new asyncRequest('STUDENT_SET_USER_DASHBOARD_LANGUAGE'),
    STUDENT_METADATA: new asyncRequest('STUDENT_METADATA'),

    // change app attributes
    STUDENT_CHANGE_APP_LANGUAGE: new asyncRequest('STUDENT_CHANGE_APP_LANGUAGE'),

    // self-service access code
    STUDENT_CREATE_SELF_ACCESS_CODE: new asyncRequest('STUDENT_CREATE_SELF_ACCESS_CODE'),

    // password management
    STUDENT_SET_PASSWORD: new asyncRequest('STUDENT_SET_PASSWORD'),
}

export const studentActions = {
    getStudentInfo(appVersion) {
        return {
            type: studentConstants.STUDENT_GET_USER_INFO.REQUEST,
            payload: {
                appVersion,
            },
        }
    },
    setStudentDashboardLanguage(languageId) {
        return {
            type: studentConstants.STUDENT_SET_USER_DASHBOARD_LANGUAGE.REQUEST,
            payload: {
                languageId,
                appLanguageId: languageId,
                deviceId: JSON.parse(localStorage.getItem('deviceGuid'))?.deviceGuid,
            },
        }
    },

    getStudentLanguageMetadata() {
        return {
            type: studentConstants.STUDENT_METADATA.REQUEST,
            payload: {},
        }
    },

    changeAppLanguage(languageId) {
        return {
            type: studentConstants.STUDENT_CHANGE_APP_LANGUAGE.REQUEST,
            payload: {
                appLanguageId: languageId,
                deviceId: JSON.parse(localStorage.getItem('deviceGuid'))?.deviceGuid,
            },
        }
    },

    createSelfAccessCode() {
        return {
            type: studentConstants.STUDENT_CREATE_SELF_ACCESS_CODE.REQUEST,
            payload: {},
        }
    },

    setPassword(newPassword) {
        return {
            type: studentConstants.STUDENT_SET_PASSWORD.REQUEST,
            payload: {
                newPassword,
            },
        }
    },
}
